import React from "react";
import moment from "moment";
import momentTz from "moment-timezone";
import { Row, Col } from "antd";
import {
  RedoOutlined,
  DownSquareOutlined,
  ShareAltOutlined,
  CodeFilled,
  ScheduleOutlined,
  LinkOutlined,
} from "@ant-design/icons";
import { connect } from "react-redux";
import { startRefresh, startGetMonitorHistory } from "../actions/checks.js";
import { Tooltip } from "react-tippy";
import DatePopUp from "./DatePopUp";
import "react-tippy/dist/tippy.css";
import PopUp from "./PopUp.js";
import CommandPopUp from "./CommandPopUp.js";
import { dashboardUrl } from "../actions/consts/host";
import "../styles/components/monitor-header.scss";

class MonitorHeader extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isDateShown: false,
      isCommandShown: false,
      isShareShown: false,
    };
  }

  refresh = () => {
    const isToday = moment(this.props.data.data.last_check_at).isSame(
      moment(),
      "day"
    );
    this.props.startRefresh(this.props.data.id, isToday);
  };

  openDate = () => {
    this.setState(() => ({
      isDateShown: true,
    }));
  };

  openShare = () => {
    this.setState(() => ({
      isShareShown: true,
    }));
  };

  openCommand = () => {
    this.setState(() => ({
      isCommandShown: true,
    }));
  };

  closeDatePopUp = () => {
    this.setState(() => ({
      isDateShown: false,
    }));
  };

  closeCommandPopUp = () => {
    this.setState(() => ({
      isCommandShown: false,
    }));
  };

  closeSharePopUp = () => {
    this.setState(() => ({
      isShareShown: false,
    }));
  };

  setDate = (date) => {
    this.props.startGetMonitorHistory(this.props.data.id, date);
  };

  render() {
    const isShare = this.props.isShare;
    const isToday = this.props.data.data.last_check_at
      ? moment(this.props.data.data.last_check_at).isSame(moment(), "day")
      : true;
    const timeZone = isToday ? momentTz.tz.guess() : "UTC";
    const now = isToday
      ? moment(this.props.data.data.fetch_time).format("MMM Do, HH:mm:ss")
      : moment(this.props.data.data.fetch_time).utc().format("MMM Do");
    const lastCheckAt = isToday
      ? moment(this.props.data.data.last_check_at).format("MMM Do, HH:mm:ss")
      : moment(this.props.data.data.last_check_at).utc().format("MMM Do");

    const date = isToday
      ? moment(this.props.data.data.last_check_at)
      : moment(this.props.data.data.last_check_at)
          .utc()
          .hour(12)
          .minute(0)
          .second(0);
    return (
      <div className="monitor-header">
        <Row gutter={32} type="flex" justify="center">
        {!isShare ? (
          <>
            <Col xxl={12} xl={12} md={12} sm={12} xs={12}>
              <div className="monitor-header--left">
                <button type="button" onClick={this.refresh}>
                  <Tooltip
                    title={`${isToday ? "Refresh" : "Go Today"}`}
                    size="big"
                    theme="light"
                    position="bottom"
                  >
                    <p className="icon">
                      {isToday ? <RedoOutlined /> : <DownSquareOutlined />}
                    </p>
                  </Tooltip>
                </button> 
                <button type="button" onClick={this.openShare}>
                  <Tooltip
                    title="Share"
                    size="big"
                    theme="light"
                    position="bottom"
                  >
                    <p className="icon">
                      <ShareAltOutlined />
                    </p>
                  </Tooltip>
                </button>
            </div>
          </Col>
          <Col xxl={12} xl={12} md={12} sm={12} xs={12}>
            <div className="monitor-header--right">
                <button type="button" onClick={this.openCommand}>
                  <Tooltip
                    title="Command"
                    size="big"
                    theme="light"
                    position="bottom"
                  >
                    <p className="icon">
                      <CodeFilled />
                    </p>
                  </Tooltip>
                </button>
                <button type="button" onClick={this.openDate}>
                  <Tooltip
                    title="Date"
                    size="big"
                    theme="light"
                    position="bottom"
                  >
                    <p className="icon">
                      <ScheduleOutlined />
                    </p>
                  </Tooltip>
                </button>
              </div>
            </Col>
          </>
        ) : undefined}
          <Col xxl={24} xl={24} md={24} sm={24} xs={24}>
            <div className="monitor-header--mid">
              <div
                className={`monitor-header--data ${
                  this.props.data.data.is_down ? "is-down" : ""
                }`}
              >
                <p className="monitor-header--status">
                  {this.props.data.status}
                </p>
                <h2 className="monitor-header--address">
                  <Tooltip
                    title={this.props.data.name}
                    size="big"
                    theme="light"
                    position="bottom-start"
                  >
                    {this.props.data.name}
                  </Tooltip>
                </h2>
                {this.props.data.isHttp && (
                  <a
                    href={this.props.data.target}
                    className="monitor-header--link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <LinkOutlined />
                  </a>
                )}
              </div>
            </div>
          </Col>
          <Col xxl={12} xl={12} md={12} sm={12} xs={24}>
            <Tooltip
              title="Use the refresh button to fetch new updates"
              size="big"
              theme="light"
              position="bottom-start"
            >
              <p className="monitor-header--last-check">
                Last Check: {`${lastCheckAt} ${timeZone}`}
              </p>
            </Tooltip>
          </Col>
          <Col xxl={12} xl={12} md={12} sm={12} xs={24}>
            <div className="monitor-header--now">
              {isToday && <p>Now: {`${now} ${timeZone}`} </p>}
            </div>
          </Col>
        </Row>

        {this.state.isDateShown && (
          <PopUp closePopUp={this.closeDatePopUp}>
            <DatePopUp
              setDate={this.setDate}
              date={date}
              creationTime={this.props.data.creation_time}
              activePlanHistoryPeriod={this.props.activePlanHistoryPeriod}
              activePlanName={this.props.activePlanName}
              isShare={this.props.isShare}
            />
          </PopUp>
        )}
        {this.state.isCommandShown && (
          <PopUp closePopUp={this.closeCommandPopUp}>
            <CommandPopUp
              title="Command"
              data={this.props.data.terminal_command}
            />
          </PopUp>
        )}
        {this.state.isShareShown && (
          <PopUp closePopUp={this.closeSharePopUp}>
            <CommandPopUp
              title="Share URL"
              data={`${dashboardUrl}/symlink/${this.props.data.token}`}
            />
          </PopUp>
        )}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  startRefresh: (id, isRefresh) => dispatch(startRefresh(id, isRefresh)),
  startGetMonitorHistory: (id, date) =>
    dispatch(startGetMonitorHistory(id, date)),
});

export default connect(undefined, mapDispatchToProps)(MonitorHeader);
